import AbaFiltro from "../Layout/AbaFiltro";
import AbaDownload from "../Layout/AbaDownload";
import AbasService from "./AbasService";
import UnimedService from "@/shared/services/UnimedService";

export default {
  props: {
    titulo: {
      type: String
    }
  },
  components: {
    AbaDownload,
    AbaFiltro
  },
  mixins: [AbasService, UnimedService]
};
